/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DepositItemsResponse } from '../models/DepositItemsResponse';
import type { InventoryItem } from '../models/InventoryItem';
import type { SellItemsResponse } from '../models/SellItemsResponse';
import type { SteamInventoryResponse } from '../models/SteamInventoryResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InventoryService {
    /**
     * Get user's inventory
     * Returns all items in the authenticated user's inventory
     * @returns InventoryItem User's inventory items
     * @throws ApiError
     */
    public static getV1Inventory(): CancelablePromise<Array<InventoryItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/inventory',
            errors: {
                401: `Not authenticated`,
            },
        });
    }
    /**
     * Get Steam inventory
     * Fetches items from the user's Steam inventory for potential deposit
     * @returns SteamInventoryResponse Steam inventory items
     * @throws ApiError
     */
    public static getV1InventorySteamInventory(): CancelablePromise<SteamInventoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/inventory/steam-inventory',
            errors: {
                401: `Not authenticated`,
            },
        });
    }
    /**
     * Sell inventory items
     * Sells selected inventory items for site balance
     * @param requestBody
     * @returns SellItemsResponse Sale completed successfully
     * @throws ApiError
     */
    public static postV1InventorySell(
        requestBody: {
            /**
             * Array of inventory item UUIDs to sell
             */
            inventoryItemIds: Array<string>;
        },
    ): CancelablePromise<SellItemsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/inventory/sell',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid items or insufficient items`,
                401: `Not authenticated`,
            },
        });
    }
    /**
     * Deposit items from Steam
     * Creates a trade offer to deposit items from Steam inventory
     * @param requestBody
     * @returns DepositItemsResponse Trade offer created successfully
     * @throws ApiError
     */
    public static postV1InventoryDeposit(
        requestBody: Array<string>,
    ): CancelablePromise<DepositItemsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/inventory/deposit',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid items or trade URL not set`,
                401: `Not authenticated`,
            },
        });
    }
}
